module.exports = __webpack_public_path__ + "img/lbl-02.4632e689.png";